module.exports = __webpack_public_path__ + "static/media/now-frozen-mb-en.1db58463.jpg";